import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import Loader from "../loader/Loader";
import { UploadEmployeeFileReq } from "../../../interfaces/Employee/Employee";
import { toast } from "react-toastify";
import { UploadEmployeeFileAsync } from "../../../services/EmployeeService/EmployeeService";
import { DocumentCategoryDto } from "../../../interfaces/documentCategory/DocumentCategory";
import { GetAllDocumentCategoriesAsync } from "../../../services/DocumentCategoryService/DocumentCategoryService";
import { Button, Modal } from "react-bootstrap";
import dropfileicon from "../../../assets/images/dropfileicon.svg";
import Form from 'react-bootstrap/Form';

interface UploadFileModalProps {
	setShowUploadFileModal: React.Dispatch<React.SetStateAction<boolean>>;
	authToken: string;
	GetEmployeeFile: (token: string) => void;
	handleClose: () => void;
	handleShow: () => void;
	show: boolean;
}

const defaultfileFormData: UploadEmployeeFileReq = {
	file: null,
	DocumentCategoryId: 0,
};

const UploadFileModal: React.FC<UploadFileModalProps> = ({
	setShowUploadFileModal,
	authToken,
	GetEmployeeFile,
	handleClose,
	handleShow,
	show
}) => {
	const [loading, setLoading] = React.useState<boolean>(false);
	const [fileFormData, setFileFomData] =
		useState<UploadEmployeeFileReq>(defaultfileFormData);
	const [documentTypes, setDocumentTypes] = useState<DocumentCategoryDto[]>([]);
	const [formErrors, setFormErrors] = useState<{
		file?: string;
		fileType?: string;
	}>({});

	useEffect(() => {
		GetAllDocumentCategories()
	}, [])

	const GetAllDocumentCategories = async () => {
		try {
			setLoading(true);
			const documentCategoriesRes = await GetAllDocumentCategoriesAsync(authToken);
			if (documentCategoriesRes.success) {
				setDocumentTypes(documentCategoriesRes.data);
			} else {
				toast.error(documentCategoriesRes.message);
			}
		} catch (error: any) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	}

	// Handle image upload (drag and drop or file input)
	const handleImageUpload = (file: File) => {
		setFileFomData((prev) => ({
			...prev,
			file: file,
		}));
		setFormErrors((prev) => ({
			...prev,
			file: file ? undefined : "Please select an image to share.",
		}));
	};

	// const handalChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
	// 	const { name, value } = e.target;
	// 	setFileFomData((prev) => ({
	// 		...prev,
	// 		[name]: value,
	// 	}));
	// 	setFormErrors((prev) => ({
	// 		...prev,
	// 		[name]: value ? undefined : `Please enter a valid ${name}.`,
	// 	}));
	// };



	// Handle file type change

	const handleFileTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		setFileFomData((prev) => ({
			...prev,
			DocumentCategoryId: Number(e.target.value),
		}));

		setFormErrors((prev) => ({ ...prev, fileType: undefined }));

	};

	const handleUploadBtnClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		console.log("File Form Data:", fileFormData);
		const newErrors: typeof formErrors = {};
		if (!fileFormData.file) {
			newErrors.file = "Please select a file to upload.";
		}
		if (!fileFormData.DocumentCategoryId || fileFormData.DocumentCategoryId == 0) {
			newErrors.fileType = "Please select a file type.";
		}
		if (Object.keys(newErrors).length > 0) {
			toast.error("Please fill in all required fields.");
			setFormErrors(newErrors);
			return;
		}
		if (!authToken) {
			toast.error("Authentication token is missing.");
			return;
		}
		setLoading(true);
		try {
			const response = await UploadEmployeeFileAsync(
				fileFormData.file as File,
				fileFormData.DocumentCategoryId,
				authToken
			);
			if (response.success) {
				toast.success(response.message);
				GetEmployeeFile(authToken); // Refresh the file list 
				setShowUploadFileModal(false);
			} else {
				toast.error(response.message || "Failed to upload file.");
			}
		} catch (error) {
			toast.error(
				`Error uploading file: ${error instanceof Error ? error.message : String(error)
				}`
			);
		} finally {
			setLoading(false);
		}
	};
	return (
		<>
			{loading && <Loader />}

			{/* <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
				<motion.div
					className="bg-white p-6 rounded shadow-lg w-full max-w-md"
					initial={{ y: "-100px", opacity: 0 }}
					animate={{
						y: "0px",
						opacity: 1,
						transition: { type: "spring", stiffness: 120 },
					}}
				>
					<div className="flex justify-between items-center mb-4">
						<h2 className="text-xl font-bold">
							Upload Employee File
						</h2>
						<button
							className="text-gray-500 hover:text-gray-800"
							onClick={() => {
								setShowUploadFileModal(false);
							}}
						>
							<FontAwesomeIcon icon={faXmark} />
						</button>
					</div>
					<div>
						<form>
							
							<div className="mb-4">
								<label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
									File Type
								</label>
								
								<select
									className="w-full px-3 py-2 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
									value={fileFormData.DocumentCategoryId}
									onChange={handleFileTypeChange}
								>
									<option value="">Select File Type</option>
									{documentTypes.length == 0 ? (
										<option value="" disabled>No Data</option>
									) : (
										documentTypes.map((type) => (
											<option
												key={type.id}
												value={
													type.id
												}
											>
												{type.documentCategoryName}
											</option>
										))
									)}
								</select>
								{formErrors.fileType && (
									<small className="text-red-700">
										{formErrors.fileType}
									</small>
								)}
							</div>

							
							<div
								className="w-full h-40 flex flex-col items-center justify-center border-2 border-dashed border-gray-400 dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-300 cursor-pointer mb-6"
								onDragOver={(e) => e.preventDefault()}
								onDrop={(e) => {
									e.preventDefault();
									const file = e.dataTransfer.files[0];
									if (file) {
										handleImageUpload(file);
									}
								}}
								onChange={(e) => {
									const target = e.target as HTMLInputElement;
									const file = target.files?.[0];
									if (file) {
										handleImageUpload(file);
									}
								}}
							>
								<p className="text-center text-sm mb-2">
									Drag and drop an Doc here
								</p>

								
								<button
									type="button"
									onClick={() =>
										document
											.getElementById("imageUploadInput")
											?.click()
									}
									className="px-3 py-1 text-sm rounded bg-gray-600 text-white hover:bg-gray-500"
								>
									{fileFormData.file
										? fileFormData.file.name
										: "Select Image"}
								</button>

								<input
									id="imageUploadInput"
									type="file"
									className="hidden"
									onChange={(e: any) => {
										const file = e.target.files[0];
										if (file) {
											handleImageUpload(file);
										}
									}}
								/>
								{formErrors.file && (
									<small className="text-red-700">
										{" "}
										{formErrors.file}
									</small>
								)}
							</div>

						
							<div className="flex justify-end">
								<button
									onClick={() => {
										setShowUploadFileModal(false);
									}}
									className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-600"
								>
									Close
								</button>

								<button
									className="mx-3 px-4 py-2 bg-green-700 text-white rounded hover:bg-gray-600"
									onClick={(e) => handleUploadBtnClick(e)}
								>
									Upload
								</button>
							</div>
						</form>
					</div>
				</motion.div>
			</div> */}

			<Modal className="custom_popup" show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
				<Modal.Header closeButton>
					<Modal.Title>Upload Employee File</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group className="custom_input_flled" controlId="exampleForm.ControlInput1">
						<Form.Label>File Type</Form.Label>
						<Form.Select aria-label="Default select example" onChange={handleFileTypeChange}>
							<option value="">Select file type</option>
                            {documentTypes.map((item)=>(
                                <option key={item.id} value={item.id}>{item.documentCategoryName}</option>
                            ))}
						</Form.Select>
                        {formErrors.fileType && (
									<small className="text-red-700">
										{formErrors.fileType}
									</small>
								)}
					</Form.Group>
                    <Form.Group className="custom_input_flled mb-0" controlId="exampleForm.ControlInput1">
                        <Form.Label>Select a file</Form.Label>
                        <div className="my_file_upload">
                            <input
                                type="file"
                                id="file_upload"
                                className="d-none"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                        handleImageUpload(file);
                                    }
                                }}
                            />
                            <label htmlFor="file_upload">
                                <div className="file_upload_img">
                                    <img style={{width: '2rem'}} src={dropfileicon} alt="dropfileicon" />
                                </div>
                                <div className="file_upload_txt">
                                    <h6 className="mb-0">{fileFormData.file
                                        ? fileFormData.file.name : 'Click to upload'}</h6>
                                </div>
                            </label>
                            {formErrors.file && (
                                <small className="text-red-700">
                                    {formErrors.file}
                                </small>
                            )}
                        </div>
                    </Form.Group>

				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={()=>{
                        handleClose();
                        setFileFomData(defaultfileFormData);
                        setFormErrors({});
                    }}>
						Cancel
					</Button>
					<Button variant="primary" onClick={(e) => handleUploadBtnClick(e)}>Upload</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default UploadFileModal;
